import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'a-avatar',
    templateUrl: './a-avatar.component.html',
    styleUrls: ['./a-avatar.component.scss'],
    standalone: false
})
export class AAvatarComponent implements OnInit {
    @Input()
    public sizeAvatar: SizeAvatar = 'DEFAULT';

    @Input()
    public roleAvatar: RoleAvatar = 'TAG';

    constructor() { }

    public fromSizeAvatar = fromSizeAvatar;
    public fromRoleAvatar = fromRoleAvatar;

    ngOnInit(): void {
    }
}

export type SizeAvatar = 'DEFAULT' | 'LARGE' | 'SMALL' | 'TINY';

export function fromSizeAvatar(sizeAvatar: SizeAvatar): string {
    switch (sizeAvatar) {
        case 'DEFAULT':
            return '_default';
        case 'LARGE':
            return '_large';
        case 'SMALL':
            return '_small';
        case 'TINY':
            return '_tiny';
    }
}

export type RoleAvatar = 'TAG' | 'USER' | 'COMPANY' | 'TECHNO';

export function fromRoleAvatar(roleAvatar: RoleAvatar): string {
    switch (roleAvatar) {
        case 'TAG':
            return '_tag';
        case 'USER':
            return '_user';
        case 'COMPANY':
            return '_company';
        case 'TECHNO':
            return '_techno';
    }
}

